import { render, staticRenderFns } from "./wxindex.vue?vue&type=template&id=7c6db63c&scoped=true"
import script from "./wxindex.vue?vue&type=script&lang=js"
export * from "./wxindex.vue?vue&type=script&lang=js"
import style0 from "./wxindex.vue?vue&type=style&index=0&id=7c6db63c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6db63c",
  null
  
)

export default component.exports